<script lang="ts">
    import { ROUTES } from '../../../helpers/routes';
    export let currentPath: string = '';
    export let getFullRoute: (path: string) => string = (path: string) => path;
    export let onActionClick: (path: string) => void = (path: string) => {alert('hehhe')};
    export let onLogout: () => void = () => {};
</script>


<div class="app_bar">
    <div class="left">
        <span
            class={`app_bar_action ${currentPath === getFullRoute(ROUTES.MAPPER) ? 'active': ''}`}
            on:click={() => onActionClick(ROUTES.MAPPER)}
        >
            Mapper
        </span>
        <span
            class={`app_bar_action ${currentPath === getFullRoute(ROUTES.HISTORY) ? 'active': ''}`}
            on:click={() => onActionClick(ROUTES.HISTORY)}>History</span
        >
    </div>
    <div class="right">
        <span
            class={`app_bar_action`}
            on:click={onLogout}>Logout</span
        >
    </div>
</div>

<style lang="scss">
    @import './header.scss';
</style>